export enum ModeType {
    WIDGET = 'WIDGET',
    RESERVATION = 'RESERVATION',
}
